import { render, staticRenderFns } from "./rollingCard.vue?vue&type=template&id=231a266a&scoped=true&"
import script from "./rollingCard.vue?vue&type=script&lang=js&"
export * from "./rollingCard.vue?vue&type=script&lang=js&"
import style0 from "./rollingCard.vue?vue&type=style&index=0&id=231a266a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a266a",
  null
  
)

export default component.exports